<template>
  <div class="wrapper fadeInDown">
    <div id="formContent">
      <!-- Tabs Titles -->

      <!-- Icon -->
      <div class="fadeIn first">
        <img src="assets/img/logo1.png" id="icon" alt="User Icon" />
      </div>

      <input
        type="text"
        class="fadeIn second "
        name="username"
        placeholder="Username"
        required
        v-model="form.inputEmail"
      />
      <input
        type="password"
        class="fadeIn third"
        name="password"
        placeholder="Password"
        required
        v-model="form.inputPassword"
      />

      <button
        :disabled="loading"
        id="loginbtn"
        @click="login"
        type="submit"
        class="fadeIn fourth"
        style="display:inline;"
      >
        <div v-if="loading" class="spinner-grow" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <span v-else>Log In</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,

      form: {
        inputEmail: null,
        inputPassword: null,
        action: 'login',
        relocate: 'login'
      }
    }
  },
  methods: {
    login() {
      this.loading = true
      let form = new FormData()
      form.append('inputEmail', this.form.inputEmail)
      form.append('inputPassword', this.form.inputPassword)
      form.append('action', this.form.action)
      form.append('relocate', this.form.relocate)
      fetch('https://irecharge.com.ng/control1.php', {
        method: 'POST',
        body: form
      })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if (data.status === 100 || data.status === 1) {
            //login successfull
            sessionStorage.setItem('username', data.username)
            sessionStorage.setItem('message', data.message)
            sessionStorage.setItem('userId', data.userid)
            sessionStorage.setItem('loggedIn', true)

            this.$router.push('/dashboard')
            this.$swal(data.message)
            this.loading = false
          } else {
            this.$swal('Invalid username or password')
            this.loading = false
          }
        })
        .catch(err => {
          console.log(err)
          this.$swal({
            icon: 'error',
            title: 'Please check your connection'
          })
          this.loading = false;
        })
    }
  }
}
</script>
